module.exports = "/_next/static/images/mockup3-50b84905447067ae6ad0474c5266fa6a.png";